import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { toggleTheme } from "../actions/appearance";

function ThemeToggler(props) {
  const { toggleTheme, theme } = props;

  const sunIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className="fill-current text-inverse"
    >
      <path
        fillRule="evenodd"
        d="M7.61 22.6l-1.68-4.53L1.4 16.4 3.41 12l-2-4.39 4.52-1.68L7.6 1.4 12 3.41l4.39-2 1.68 4.52L22.6 7.6 20.59 12l2 4.39-4.52 1.68-1.68 4.53L12 20.59l-4.39 2zM12 18.39l3.26 1.5 1.26-3.37 3.36-1.26L18.4 12l1.5-3.26-3.37-1.26-1.26-3.36L12 5.6l-3.26-1.5-1.26 3.37-3.36 1.26L5.6 12l-1.5 3.26 3.37 1.26 1.26 3.36L12 18.4zM12 17a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6z"
      />
    </svg>
  );

  const moonIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className="fill-current text-inverse"
    >
      <path
        fillRule="evenodd"
        d="M15.24 3.87a7 7 0 005.2 12.12l2-.13-1.11 1.68a9.99 9.99 0 11-6.6-15.39l1.99.35-1.48 1.37zM5 12a8 8 0 0013.44 5.87 9 9 0 01-5.93-13.85A8 8 0 005 12z"
      />
    </svg>
  );

  return (
    <div>
      <button
        onClick={() => {
          toggleTheme(theme);
        }}
        className="rounded-full bg-secondary p-1 focus:outline-none focus:shadow-outline"
      >
        {theme === `light` ? moonIcon : sunIcon}
      </button>
      {/* <input
        className="hidden screenreader-only"
        type="checkbox"
        aria-label="Switch between Dark and Light mode"
        checked=""
      ></input> */}
    </div>
  );
}

ThemeToggler.propTypes = {
  theme: PropTypes.string.isRequired,
  toggleTheme: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  theme: state.appearance.theme
});

export default connect(
  mapStateToProps,
  { toggleTheme }
)(ThemeToggler);
